export default __webpack_public_path__ + "static/media/img_06.ebd14a82.jpg";